import { defineMessages } from 'react-intl';
export default defineMessages({
  cpfOrder: {
    id: 'cpfOrder',
    defaultMessage: '{userTitle} had a {conversation} communication on {date} with {doctor} wherein {doctor} approved the following frequency change.\n{orderChanges}\nOrder verified via verbal or secure electronic communication and electronically signed by {userCredentials} on {signDate}.'
  },
  cpfPhysOrder: {
    id: 'cpfPhysOrder',
    defaultMessage: 'I, {userCredentials}, approved the following frequency change.\n{orderChanges}\nElectronically signed by {userCredentials} on {signDate}.'
  }
});